import { validStyles } from "@tamagui/helpers";
import { stackDefaultStyles } from "../constants/constants.mjs";
import { createComponent } from "../createComponent.mjs";
const View = createComponent({
  acceptsClassName: !0,
  defaultProps: stackDefaultStyles,
  validStyles
});
export { View };
//# sourceMappingURL=View.mjs.map
